import MetierDetails from "./MetierDetails";

export default MetierDetails;
